import { ANALYTIC_SET_LIST } from './actionTypes';
import { analyticApi } from 'helpers/api/analytic';

export const Analytic = {
  getAnalyticList: (queryParams = {}) => async (dispatch) => {
    return analyticApi.getAnalytics(queryParams).then(({ data } = {}) => {
      dispatch(Analytic.setListAction(data));
    });
  },
  setListAction: (payload) => ({
    type: ANALYTIC_SET_LIST,
    payload,
  }),
};
